export enum CustomHeaderAction {
  PinCanvas = `pin-canvas`,
  ShowMetricValue = `show-metric-value`,
  ShowSparkline = `show-sparkline`,
  ShowCorrelation = `show-correlation`,
}
